//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { logToSentry } from "utils/networkErrorUtils";
import { handleListUserClasses } from "store/userClasses/thunks";
import { apis } from 'utils/lib/apis';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List resources ----------------


//  -- List resources ----------------


export const getRefreshToken = async (code) => {
  const token = await apis.post("googleClassRoom", "/getRefreshToken", {
    body: {
      code,
      "redirect_uri":document.location.origin
    }
  })
  return token;
}


export const handleGooleClassRoomUserRegistration = async (key) => {
  try {
    return apis.post("googleClassRoom", "/handleUser", {
      body: {
        "access_token": key
      }
    })
  } catch (error) {
    return null;
  }

}
export const handleGoogleUserClasses = async (id) => {
  try {
    return apis.post("googleClassRoom", "/handleUserCourses", {
      body: {
        googleId:id
      }
    })
  } catch (error) {
    return null;
  }

}
export const handleGoogleClassRoomStudents = async (id,classId) => {
  try {
    return apis.post("googleClassRoom", "/handleStudent", {
      body: {
        googleId:id,
        classId
      }
    })
  } catch (error) {
    return null;
  }

}
export const handleUpdateGradeToGoogleClassRoom = async ( teacherGoogleId, studentGoogleId, googleCourseId, assignmentId, grade ) => {
  try {
    return apis.put("googleClassRoom", "/updateGrade", {
      body: {
        teacherGoogleId, 
        studentGoogleId, 
        googleCourseId, 
        assignmentId, 
        grade
      }
    })
  } catch (error) {
    return null;
  }

}

let googleGradeQueue = []; 
let googleDebounceTimer = null; 

export const handleUpdateGoolgeGradeInBatch = async (teacherGoogleId, studentGoogleId, googleCourseId, assignmentId, grade) => {
    return new Promise((resolve) => {
      if(!assignmentId) return null;
        const hasValueIndex = googleGradeQueue.findIndex((item) => item.studentGoogleId == studentGoogleId && item.googleCourseId == googleCourseId && item.assignmentId == assignmentId );
        if (hasValueIndex > -1) {
            googleGradeQueue[hasValueIndex] = {
              studentGoogleId, googleCourseId, assignmentId, grade
            };
        } else {
            googleGradeQueue.push({
               studentGoogleId, googleCourseId, assignmentId, grade
            });
        }
        if (googleDebounceTimer) {
            clearTimeout(googleDebounceTimer);
        }
        googleDebounceTimer = setTimeout(async () => {
            try {
                const response = await apis.post("googleClassRoom", "/update_grade_in_batch", {
                    body: {
                      teacherGoogleId,
                      assignments:googleGradeQueue
                    },
                });
                googleGradeQueue = [];
                resolve(response); 
                return response;
            } catch (error) {
                console.log("Error updating Google grades in batch:", error);
                resolve(null); 
                return null;
            }
        }, 4000);
    });
};

export const handleCreateGoogleAssignment = async (googleId, assignment,courseId) => {
  try {
    return apis.post("googleClassRoom", "/createAssignmentAwsQueue", {
      body: {
        googleId,
        assignment,
        googleClassId:courseId
      }
    })
  } catch (error) {
    return null;
  }
}
export const handleDeleteGoogleAssignment = async (googleId, activityId, classAssignmentId = []) => {
  try {
    return apis.post("googleClassRoom", "/deleteAssignment", {
      body: {
        googleId,
        activityId,
        classAssignmentId,
        // googleClassId:courseId
      }
    })
  } catch (error) {
    return null;
  }
}
export const handleUpdateGoogleAssignment = async (googleId, assignment,courseId, assignmentId) => {
  try {
    return apis.put("googleClassRoom", "/updateAssignment", {
      body: {
        googleId,
        assignment,
        assignmentId,
        googleClassId:courseId
      }
    })
  } catch (error) {
    return null;
  }
}
export const handleSyncClassworkGeades = async (googleId,classId,googleCourseId) => {
  try {
    return apis.put("googleClassRoom", "/synAssignmentGrade", {
      body: {
        googleId,
        classId,
        googleCourseId
      }
    })
  } catch (error) {
    return null;
  }
}
export const handleSyncClassworkAssignment = async (googleId,classId) => {
  try {
    return apis.post("googleClassRoom", "/syncClassAssignment", {
      body: {
        googleId,
        classId
      }
    })
  } catch (error) {
    logToSentry({
        message: 'Error during Google Classroom sync assignment',
        error,
        module: 'GOOGLE_CLASSROOM',
        operation: 'SYNC_ASSIGNMENT'
    });
    return null;
  }
}
export const handleUserByGoogleName = async (name) => {
  if(typeof name!="string") return [];
  try {
      const user = await apis.post("googleClassRoom", `/listUserByName`,{
        body:{
          title: name
        }
      })
      return user;

  } catch (error) {
      return []
  }
}
export const handleUserByGoogleId= async (googleId) => {
  if(!googleId) return [];
  try {
      const user = await apis.post("googleClassRoom", `/getUserInfoById`,{
        body:{
          googleId
        }
      })
      return user;

  } catch (error) {
      return []
  }
}

export const getGoogleClassForUser = async (googleId) => {
  if (!googleId) return [];
  try {
    const data = await apis.get("googleClassRoom", `/getGoogleClassForUser/${googleId}`)
    return data;

  } catch (error) {
    return ({
      error: "Failed to fetch Google classes for user."
    })
  }
}
export const synCourseForGoogleClassRoom = (userId,googleId,classInfo) => async (dispatch) => {
    if (!googleId) return { success: false };

    try {
      const data = await apis.post("googleClassRoom", `/syncCourse/`, {
        body: { googleId, classInfo }
      });

      await dispatch(handleListUserClasses(userId));

      return { success: true, data };
    } catch (error) {
      return { success: false, error: "Failed to fetch Google classes for user." };
    }
  };

export const handleSyncAssignmentGradeToGoogleClassroom = async (googleId,assignmentId,gradeCategoryId) => {
  try {
    return apis.post("googleClassRoom", "/sync_assignment_grade_to_googleclassroom", {
      body: {
        teacher_google_id: googleId,
        assignment_id: assignmentId,
        grade_category_id: gradeCategoryId  
      }
    });
  } catch (error) {
    return ({
      error: error.message
    })
  }
};